export default __webpack_public_path__ + "static/media/qi-nqf.eb3fe90f.jpg";